export const PresentationTypeConst = {
  demo: 'presentation',
  tour: 'tour_presentation',
  play: 'play',
  url: 'external_url_presentation',
} as const;

export type PresentationTypes = {
  demo: 'presentation';
  tour: 'tour_presentation';
  play: 'play';
  url: 'external_url_presentation';
};

export type PresentationType =
  (typeof PresentationTypeConst)[keyof PresentationTypes];
